var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading",class:{ centered: _vm.centered, opaque: _vm.opaque }},[_c('b-spinner',{staticClass:"align-middle"}),_c('strong',{staticClass:"ml-2"},[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }